import { MediaType } from '@/contexts/chat/scripts/hooks/useQuickVO/types';
import { useChatContext } from '@/contexts/chat/context';
import UnMuteIcon from '../../images/un_mute.svg?react';

const DrawSpeak = ({ member, callUserInfo, callUserStream }: any) => {
  const { chatMediaQuickVO } = useChatContext();
  const { drawSpectrum, clearRequestAnimationFrame } = chatMediaQuickVO;
  const [hasAudioStream, setHasAudioStream] = useState(true);

  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const frameId = `${member.userId}-${MediaType.MICROPHONECAMERA_AUDIO}`;
    if (canvasRef.current && callUserInfo?.callActionMap.microphoneCamera_audio) {
      setHasAudioStream(true);
      drawSpectrum(
        member.userId,
        MediaType.MICROPHONECAMERA_AUDIO,
        canvasRef.current,
        frameId,
        () => {
          setHasAudioStream(false);
          return Promise.resolve(false);
        }
      );
    }
    return () => clearRequestAnimationFrame(frameId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    drawSpectrum,
    member.userId,
    canvasRef.current,
    callUserInfo?.callActionMap.microphoneCamera_audio,
    callUserStream?.updateStreams,
  ]);

  return hasAudioStream ? (
    <canvas width={17} height={12} ref={canvasRef}></canvas>
  ) : (
    <UnMuteIcon></UnMuteIcon>
  );
};

export default DrawSpeak;
